import React from 'react';

export const LocaleContext = React.createContext('en');
export const CountryContext = React.createContext(null);
export const RegionContext = React.createContext(null);
export const DatelineContext = React.createContext(null);
export const ContentContext = React.createContext({});
export const GlobalTopojsonContext = React.createContext(null);
